export const MODULE_NAME = "TRANSACTIONS";

export const lang = {
	pageTitle: "Transactions",
	updateinvoice: "Update Invoice",
};

export enum flowActionTypes {
	BULK_APPROVED = "BULK_APPROVED",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED",
	UPLOAD_INVOICE = "UPLOAD_INVOICE",
	VIEW_INVOICE = "VIEW_INVOICE",
	DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE",
	VIEW_DELIVERY = "VIEW_DELIVERY",
	DOWNLOAD_DELIVERY = "DOWNLOAD_DELIVERY",
}

export const fieldsName = {
	pendingTransactions: "Pending transactions",
	transactionHistory: "Transaction history",
	rejectReason: "rejectReason",
};
